var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSidebarIcon1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.899,
    height: 14.399,
    viewBox: "0 0 19.899 14.399",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12513",
    "data-name": "Group 12513",
    transform: "translate(1218 53)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12512",
    "data-name": "Group 12512",
    transform: "translate(-1134.134 -174.601)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_40573",
    "data-name": "Path 40573",
    d: "M25.033,171l-7.2-7.2,7.2-7.2h-4.7l-7.2,7.2,7.2,7.2Z",
    transform: "translate(-97 -35)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40574",
    "data-name": "Path 40574",
    d: "M33.033,171l-7.2-7.2,7.2-7.2h-4.7l-7.2,7.2,7.2,7.2Z",
    transform: "translate(-97 -35)",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarIcon1);
export default __webpack_public_path__ + "static/media/sidebar-icon-1.20c4afe32d3a0494b3f03f8c6af0259f.svg";
export { ForwardRef as ReactComponent };